import React from 'react';
import { Link } from 'react-router-dom';
import './CitiesWithListings.css';

export default function CitiesWithListings({ cities }) {
    if (!cities || cities.length === 0) {
        return null;
    }

    return (
        <section className="cities-listings-section">
            <div className="cities-listings-container">
                <div className="cities-listings-header">
                    <h2 className="cities-listings-title">Cities with Business Listings</h2>
                    <p className="cities-listings-subtitle">Explore local businesses in these cities</p>
                </div>

                <div className="cities-listings-grid">
                    {cities.map((city) => (
                        <Link
                            key={city.id}
                            to={`/in/${city.stateSlug}/${city.slug}`}
                            className="cities-listings-card"
                        >
                            <div className="cities-listings-info">
                                <div className="cities-listings-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                                        <circle cx="12" cy="9" r="2.5" />
                                    </svg>
                                </div>
                                <div className="cities-listings-text">
                                    <span className="cities-listings-name">{city.name}</span>
                                    {city.stateName && (
                                        <span className="cities-listings-state">{city.stateName}</span>
                                    )}
                                </div>
                            </div>
                            <svg
                                className="cities-listings-arrow"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
